import React from "react";
import MembersTable from "./MembersTable";

const CategoryRow = ({
  category,
  index,
  isExpanded,
  onToggleExpand,
  membersData,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onToggleExpand(category.category_id);
    }
  };

  const {
    loading = false,
    error = null,
    data: members = [],
  } = membersData || {};

  return (
    <>
      <tr
        tabIndex={0}
        role="button"
        aria-expanded={isExpanded}
        aria-controls={`cwm-category-members-${category.category_id}`}
        style={{ cursor: "pointer" }}
        onClick={() => onToggleExpand(category.category_id)}
        onKeyDown={handleKeyDown}
      >
        <td>{index + 1}</td>
        <td>
          <div className="d-flex align-items-center">
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.2s ease",
                transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                marginRight: "8px",
                color: "#c4161c",
              }}
              aria-hidden="true"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </span>
            <span className="fw-bold">{category.category_name}</span>
          </div>
        </td>
        <td className="text-end fw-bold">{category.total_members}</td>
        <td className="text-end fw-bold text-success">{category.active_members}</td>
        <td className="text-end fw-bold text-danger">{category.inactive_members}</td>
      </tr>

      {isExpanded && (
        <tr id={`cwm-category-members-${category.category_id}`}>
          <td colSpan={5} className="p-0">
            <MembersTable
              members={members}
              loading={loading}
              error={error}
              categoryName={category.category_name}
              onRetry={() => onToggleExpand(category.category_id, true)}
            />
          </td>
        </tr>
      )}
    </>
  );
};

export default CategoryRow;
